import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { UserdataContext } from '../../../../App'
import SearchInput from '../../search-input'
import logo from '../../../../assets/images/logo.svg'
import arrow from '../../../../assets/icons/arrow_white.png'
import offers from '../../../../assets/icons/offers.png'
import savedIcon from '../../../../assets/icons/saved.svg'
import teamDashboard from '../../../../assets/icons/team-dashboard.svg'
import viewAgenda from '../../../../assets/icons/view-agenda.svg'
import docsAdd from '../../../../assets/icons/docs-add.svg'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import { getAuthToken, clearAllTokens } from '../../../../insfrastructure/services/token-manager'
import './styles.sass'


export const DeskHeader = () => {
  const navigate = useNavigate()
  const [showUserMenu, toggleUserMenu] = useState(false)
  const {userData, setUserData} = useContext<any>(UserdataContext)
  const usertypes: any = {
    'candidate': 'Candidato',
    'job_manager': 'Empresa'
  }

  // Verifica se o usuário tem perfil em_job_manager (bloqueio temporário)
  const hasEmJobManager = () => {
    try {
      const token = getAuthToken();
      if (!token) return false;
      const parsedJWT = parseJwt(token);
      return parsedJWT?.profiles?.includes('em_job_manager') || false;
    } catch (error) {
      return false;
    }
  }

  useEffect(() => {
    window.addEventListener('click', (e) => {
      let userDataElement = document.querySelector('.user-data') as HTMLElement;
      if(!userDataElement) return;

      if(userDataElement.contains(e.target as HTMLElement)) {
        userDataElement = document.querySelector('.user-data') as HTMLElement;
        toggleUserMenu(userDataElement.classList.contains('opened') ? false : true);        
      } else {
        toggleUserMenu(false);
      };
    });
  }, [])

  const onLogout = () => {
    clearAllTokens();
    toggleUserMenu(false);
    setUserData(null);
    navigate('/login');
  }
  
  return (
    <header className='desk'>
      <div className='content'>
        <Link to=''><img className='logo' src={logo} alt='logo' /></Link>
        <div className='left-content'>
          {!userData &&
          <div className='home-links'>
            <Link to='offers'>
              <li>Vagas</li>
            </Link>
            <Link to='how-to-anounce'>
              <li>Como anunciar</li>
            </Link>
            <Link to='about-us'>
              <li>Sobre nós</li>
            </Link>
            <Link to='success-stories'>
              <li>Histórias</li>
            </Link>
          </div>}
          {userData?.usertype === 'candidate' &&
          <div className='offer-links'>
            <Link to='offers'>
              <li>
                <img src={offers} alt='offers-icon' />
                <span>Vagas</span>
              </li>
            </Link>
            <Link to='profile/candidate/subscriptions'>
              <li>
                <img src={savedIcon} alt='saved-icon' />
                <span>Vagas salvas</span>
              </li>
            </Link>
            <Link to='job-subscriptions'>
              <li>
                <img src={offers} alt='job-subscriptions-icon'/>
                <span>Candidaturas</span>
              </li>
            </Link>
          </div>}
          {userData?.usertype === 'job_manager' &&
          <div className='offer-links'>
            <Link to='offers/create'>
              <li>
                <img src={docsAdd} alt='docs-add-icon' />
                <span>Publicar vaga</span>
              </li>
            </Link>
            <Link to='offers/panel'>
              <li>
                <img src={teamDashboard} alt='team-dashboard-icon' />
                <span>Minhas vagas</span>
              </li>
            </Link>
            <Link to='offers'>
              <li>
                <img src={viewAgenda} alt='view-agenda-icon' />
                <span>Vagas</span>
              </li>
            </Link>
          </div>}
          {userData?.usertype === 'candidate' &&
          <SearchInput />}
        </div>
        <div className='right-content'>
          {
            userData &&
            <div className='user-menu-container'>
              <div className={'user-data '+(showUserMenu ? 'opened' : '')}>
                <div className='user-info'>
                  <h4 className='cut-text'>Olá, <b>{userData?.full_name}</b></h4>
                  <p>{usertypes[userData?.usertype]}</p>
                </div>
                <div className='profile-picture-container'>
                  {userData?.picture && <img src={userData.picture} alt='profile-picture-placeholder' />}
                </div>
                <img src={arrow} className='arrow' alt='arrow-icon' />
              </div>
              {showUserMenu &&
              <div className='user-menu'>
                <ul>
                  {!hasEmJobManager() && (
                    <Link to={
                      userData.usertype === 'candidate' 
                        ? 'profile/candidate/person' 
                        : userData.usertype === 'job_manager'
                          ? 'profile/job-manager'
                          : 'profile/company/user'
                    }><li>Meu perfil</li></Link>
                  )}
                  <li onClick={onLogout}>Sair</li>
                </ul>
              </div>}
            </div>
          }
          {!userData &&
            <ul className='unlogged-links'>
              <Link to='sign-up'><li>Cadastro</li></Link>
              <Link to='login'><li>Entre</li></Link>
            </ul>}
        </div>
      </div>
    </header>
  )
}
